<template>
  <div class="content fit_main_background" @click="toggleSidebar">
    <div class="container-fluid">
      <high-light-bar></high-light-bar>
      <div class="row">
        <div class="col-xl-4 col-md-6 curser def-height" v-for="exp in exps" :key="exp.id"
          @click="openExp(exp.id, exp.title)">
          <stats-card>
            <div v-if="exp.image" slot="image" class="icon-primary">
              <img class="exp-image" :src="exp.image" onerror="this.src='/img/load_error.png'" alt="Exp Image" />
            </div>
            <div slot="default">
              <div class="exp-title">
                <i class="fab fa-hire-a-helper" style="margin: 5px; color: #a0a0a0" aria-hidden="true"></i>
                <h3>{{ exp.title }}</h3>
              </div>
              <p class="card-text-content">{{ exp.content }}</p>
            </div>
            <div slot="footer">
              <i class="fa fa-commenting"></i>
              <span>بخوانید</span>
              <i class="fa fa-reply"></i><span style="display: inline-block;">{{exp.responses.length}}</span>
              <div style="float: right;">
                {{ exp.user.username }}
                <img :src="exp.user.avatar ? exp.user.avatar : '/img/default-avatar.png'" class="rounded-circle" style="width: 30px; height: 30px; margin-left: 5px;"
                  alt="US Flag" />
              </div>
            </div>
          </stats-card>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import StatsCard from 'src/components/Cards/StatsCard.vue';
import HighLightBar from '../components/HighLight/HighLightBar.vue';

import axios from 'axios';
import { Apis } from '../constants';


export default {
  components: {
    StatsCard,
    HighLightBar
  },
  data() {
    return {
      exps: []
    }
  },
  mounted() {
    if (this.exps.length === 0) {
      this.$loading.show();
      axios.get(Apis.get_user_related_exps, {
        withCredentials: true
      }).then(response => {
        this.exps = response.data;
        console.log(this.exps);
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.$loading.hide();
      });
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    openExp(id, slug) {
      this.$router.push({ name: 'ShowExp', params: { slug: slug, expId: id } });
    }
  }
}
</script>

<style scoped>
.curser {
  cursor: pointer;
}

.fit_main_background {
  min-height: calc(100vh - 120px);
}

.def-height {
  max-height: 400px;
}

.exp-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.exp-title {
  color: #333;
  font-size: 18px;
  font-weight: 500;
  margin-top: 5px;
  padding-bottom: 5px;
  text-align: justify;
  direction: rtl;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #a1a1a1;
}

.exp-title h3 {
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 500;
  margin-top: 5px;
  text-align: justify;
  direction: rtl;
}

.card-text-content {
  color: #999;
  font-size: 14px;
  line-height: 24px;
  margin: 0;
  text-align: justify;
}
</style>
